import Icon from '../components/Icon.vue'

Icon.register({
  columns: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h416zM224 416v-256h-160v256h160zM448 416v-256h-160v256h160z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/columns.js
// module id = 1225
// module chunks = 0